import { Text } from '@consta/uikit/Text'
import { TextField } from '@consta/uikit/TextField'
import { stopPropagation } from 'common/helpers'
import type { FC, KeyboardEventHandler } from 'react'
import { useEffect, useState } from 'react'

import { MAX_VSP_OFFSET } from '../../constants'
import { isValidInteger } from '../../types'
import css from './VspOffset.css'

type VspOffsetProps = {
  offset?: string
  onOffset?: (offset: string | undefined) => void
  withLabel?: boolean
}

export const VspOffset: FC<VspOffsetProps> = ({ offset, onOffset, withLabel }) => {
  const [value, setValue] = useState<string | undefined>(offset)

  useEffect(() => {
    if (offset) {
      setValue(offset)
    }
  }, [offset])

  const handleOffset = () => {
    if (isValidInteger(value)) {
      onOffset?.(value)
    }
  }

  const handleKeyDown: KeyboardEventHandler<HTMLInputElement> = event => {
    if (event.key !== 'Enter') return

    if (event.target instanceof HTMLInputElement) {
      event.target.blur()
    }
    handleOffset()
  }

  const baseInput = (
    <TextField
      className={css.textField}
      value={value}
      type="number"
      size="xs"
      min={-MAX_VSP_OFFSET}
      max={MAX_VSP_OFFSET}
      onChange={value => {
        setValue(value ?? undefined)
      }}
      onBlur={handleOffset}
      onKeyDown={handleKeyDown}
      onClick={stopPropagation}
    />
  )

  if (!withLabel) {
    return <div className={css.textFieldContainer}>{baseInput}</div>
  }

  return (
    <span className={`${css.offset} ${css.textFieldContainer}`}>
      <Text className={css.text} size="xs" view="ghost" display="inline">
        Сдвиг, мс
      </Text>
      {baseInput}
    </span>
  )
}
